import type { Person } from '@/store/people/types';
import type { PersonDocument } from '@/shared/types/pco/person';

/**
 * Map a MongoDB people collection document to the store Person shape
 * used by quick search and the person drawer.
 */
export function personDocumentToStorePerson(doc: PersonDocument): Person {
  const first = (doc.first_name ?? '').trim();
  const last = (doc.last_name ?? '').trim();
  const preferred = (doc.nickname ?? '').trim();
  const fullname =
    ([first, last].filter(Boolean).join(' ') ||
      preferred ||
      [doc.primary_email].filter(Boolean)[0]) ??
    '';

  return {
    id: doc.pco_id,
    data: {
      firstname: first || undefined,
      lastname: last || undefined,
      preferredname: preferred || undefined,
      fullname: fullname || undefined,
      email: doc.primary_email ?? undefined,
      phone: doc.primary_phone ?? undefined,
      member_status: doc.membership ?? doc.status ?? undefined,
      campus_id: doc.primary_campus_id ?? undefined,
      picture: doc.avatar_url ?? undefined,
      household_id: doc.household_id ?? undefined,
    },
  };
}
